import en from './en.json';
import fr from './fr.json';

export const invoicesI18n = {
  fr,
  en,
};
